import styles from './ConversationTabs.module.css';

export type ConversationTab = 'pending' | 'active' | 'closed';

interface ConversationTabsProps {
  selectedTab: ConversationTab;
  counts: Record<ConversationTab, number>;
  onChange: (tab: ConversationTab) => void;
}

export function ConversationTabs({ selectedTab, counts, onChange }: ConversationTabsProps) {
  const tabs: ConversationTab[] = ['pending', 'active', 'closed'];
  const labels: Record<ConversationTab, string> = {
    pending: 'Wachtend',
    active: 'Opvolging',
    closed: 'Afgerond',
  };
  return (
    <div className={styles.tabs} role="tablist" aria-label="Consultatie status">
      {tabs.map((tab) => (
        <button
          key={tab}
          type="button"
          role="tab"
          aria-selected={selectedTab === tab}
          className={`${styles.tab}${selectedTab === tab ? ` ${styles.tabActive}` : ''}`}
          onClick={() => onChange(tab)}
        >
          <span className={styles.tabLabel}>{labels[tab]}</span>
          <span className={styles.tabCount}>{counts[tab]}</span>
        </button>
      ))}
    </div>
  );
}
